
import Vue from "vue";
import helpers from "../inc/helpers";
import api from "../api";

import HomesteadView from "../data/HomesteadView";

export default Vue.extend({
	name: "HomesteadExemptionDetail",

	props: {
		parcelId: String,
	},

	data() {
		return {
			isLoading: true,
			taxValues: null as null | HomesteadView,
		};
	},

	mounted() {
		this.getHomesteadValues(this.parcelId);
	},

	methods: {
		getHomesteadValues(parcelId: string): Promise<boolean> {
			return new Promise((resolve, reject) => {
				api.getHomesteadView(parcelId).then((resp: HomesteadView) => {
					this.taxValues = resp;
					this.isLoading = false;

					resolve(true);
				});
			});
		},
	},

	computed: {},

	filters: {
		formatCurrency(val: string): string {
			return helpers.formatCurrency(val, true);
		},
	},

	watch: {
		parcelId() {
			this.getHomesteadValues(this.parcelId);
		},
	},

	components: {},
});
